import {
  IHighRiskSupplementCategoryDTO,
  IHighRiskSupplementDetailsResponseDTO,
  IRiskSupplementsTableData,
  IRiskSupplementWarningTypeResponseDTO,
} from '@interfaces/highRiskSupplements';

import { apiUrls } from './urls';
import { get, post, put, upload } from './utils';

export const getHighRiskSupplementsList = (dto: any) =>
  post<IRiskSupplementsTableData>(`${apiUrls.risksupplements.search}`, dto);

export const getHighRiskSupplementsDetails = (supplementId: number) =>
  get<IHighRiskSupplementDetailsResponseDTO>(`${apiUrls.risksupplements.details}/${supplementId}`);

export const getHighRiskSupplementWarningTypes = () =>
  get<IRiskSupplementWarningTypeResponseDTO>(apiUrls.lookups.warningTypes);

export const getHighRiskSupplementCategories = () =>
  get<IHighRiskSupplementCategoryDTO>(apiUrls.lookups.risksupplementcategories);
